<template>

  <div class="UsersWidget" >
    <ul class="list">
      <li v-for="user of users" @click="toggle(user.id)" :class="{ selected: selectedUsers.indexOf(user.id) > -1 }" >
        <span>{{ user.firstname }} {{ user.lastname }}</span>
        <span class="checkbox" :style="{ backgroundColor: user.color }"  ></span>
      </li>
    </ul>
  </div>

</template>

<script>
  // Vuex
  import { users, selectedUsers } from 'src/vuex/getters'
  import { getSelectedUsers, toggleSelectedUser } from 'src/vuex/actions/meetingActions'
  import { getUsers } from 'src/vuex/actions/userActions'

  export default {
    vuex: {
      getters: { users, selectedUsers },
      actions: { getUsers, getSelectedUsers, toggleSelectedUser }
    },
    data () {
      return {}
    },
    methods: {
      toggle (userId) {
        this.toggleSelectedUser(userId)
      }
    },
    ready () {
      this.getUsers()
      this.getSelectedUsers()
    }
  }
</script>

<style lang="scss" >

  .UsersWidget{
    background: $green;
    color: white;
    padding: 1em;
    .list li{
      cursor         : pointer;
      display        : flex;
      padding        : 0.5em;
      transition     : background 100ms;
      align-items    : center;
      border-radius  : 3px;
      justify-content: space-between;
      &:hover{
        background: darken($green, 5%);
      }
      &:not(:last-child){
        margin-bottom: 0.5em;
      }
    }
    .checkbox{
      width        : 2em;
      height       : 2em;
      cursor       : pointer;
      border-radius: 3px;
    }
    .list li:not(.selected) {
      opacity: 0.5;
    }
  }

</style>



// WEBPACK FOOTER //
// Users.vue?52c54b48